module.exports = {"330112002":"玲珑街道","330112005":"锦南街道","330112006":"锦城街道","330112007":"锦北街道","330112008":"青山湖街道","330112102":"高虹镇","330112103":"太湖源镇","330112104":"於潜镇","330112106":"太阳镇","330112107":"潜川镇","330112108":"昌化镇","330112109":"河桥镇","330112111":"湍口镇","330112112":"清凉峰镇","330112113":"岛石镇","330112115":"板桥镇","330112116":"天目山镇","330112117":"龙岗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330112.json
// module id = 1050
// module chunks = 0